import { useEffect, useState ,useRef} from "react";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";
import { FaEdit,FaMinusCircle} from "react-icons/fa";

export default function Classes() {

  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);
  //const [showModal, setShowModal] = useState(false);
  const academicYearId = sessionStorage.getItem('academicYearId')

  const [selectedClass, setSelectedClass] = useState(null);
   const hasFetched = useRef(false);

  const loadClasses = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.get("/classes");
      setClasses(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
      hasFetched.current = true;
    loadClasses();
  }, []);

 // handle field change
  const handleSectionChange = (index, field, value) => {
    setSelectedClass(prev => {
      const updatedSections = [...prev.sections];
      updatedSections[index] = {
        ...updatedSections[index],
        [field]: value
      };
      return { ...prev, sections: updatedSections };
    });
  };

  // handle field change
  const handleSubjectChange = (index, field, value) => {
    setSelectedClass(prev => {
      const updatedSubjects = [...prev.subjects];
      updatedSubjects[index] = {
        ...updatedSubjects[index],
        [field]: value
      };
      return { ...prev, subjects: updatedSubjects };
    });
  };

  // add new section
  const addSection = () => {
    setSelectedClass(prev => ({
      ...prev,
      sections: [...prev.sections, { sectionName: "", active: true}]
    }));
  };

  // delete section
  const deleteSection = (index) => {
    setSelectedClass(prev => {
      const updatedSections = prev.sections.filter((_, i) => i !== index);
      return { ...prev, sections: updatedSections };
    });
  };

  // add new Subject
  const addSubject = () => {
    setSelectedClass(prev => ({
      ...prev,
      subjects: [...prev.subjects, { subjectCode: "",subjectName:""}]
    }));
  };

  // delete section
  const deleteSubject = (index) => {
    setSelectedClass(prev => {
      const updatedSubjects = prev.subjects.filter((_, i) => i !== index);
      return { ...prev, subjects: updatedSubjects };
    });
  };

  const handleChange = (e) => {const { name, value } = e.target;
    setSelectedClass({
      ...selectedClass,
      [name]: value
    });
  };

  const openNew = () => {

    setSelectedClass({
      className: "",
      description: "",
      active: true,
      academicYearId:academicYearId,
      sections:[],
      subjects:[]
    });

    //setShowModal(true);
  };

  const onClose = () => {

    setSelectedClass(null);

  };

  const editClass = async (id) => {

    try {

      setLoading(true);

       const response = await axiosInstance.get(`/classes/${id}`);
      
      //setShowModal(false);
      
      if (response.data.status === "SUCCESS") {
            setSelectedClass(response.data.data);
        }else{
            if (response.data.message) {
              alert(response.data.message); 
            } else {
              alert(response.message || "Error in Retrieve Class");
            }
        }

    } catch (err) {

      console.error(err);
      alert("Error in Retrieve Class");

    } finally {

      setLoading(false);

    }

  };

  const saveClass = async () => {

    try {

      setLoading(true);

      const response = await axiosInstance.post("/classes/save", selectedClass);
      if (response.data.status === "SUCCESS") {
          alert("Class Saved Successfully");
          setSelectedClass(null);
          loadClasses();
        }else{
             if (response.data.errors && response.data.errors.length > 0) {
              alert(response.data.errors.join("\n")); // show all errors
            } else {
              alert(response.message || "Error in Saving Class");
            }
        }
    } catch (err) {

      console.error(err);
      alert("Error in Save Class");

    } finally {

      setLoading(false);

    }

  };

  return (

    <div className="p-4 md:p-6">

      {loading && <Loader />}

      {/* Header */}
      <div className="flex justify-between items-center mb-4">

        <h1 className="text-xl font-semibold">
          Classes
        </h1>

        <button
          onClick={openNew}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          New
        </button>

      </div>

      {/* Table */}
      <div className="bg-white shadow rounded-lg overflow-x-auto">

        <table className="w-full text-sm">

          <thead className="bg-gray-100">

            <tr>
              <th className="text-left p-3">Class</th>
              <th className="text-left p-3">Sections Count</th>
              <th className="text-left p-3">Subjects Count</th>
              <th className="text-left p-3">Active</th>
              {/* <th className="text-right p-3"> " "</th> */}
            </tr>

          </thead>

          <tbody>
            {classes.length > 0 ? (
              classes.map((cls) => (

              <tr key={cls.id} className="border-t">

                <td className="p-3">
                   <div className="flex items-center gap-2">
                  {cls.className}
                  <button onClick={() => editClass(cls.id)} className="text-gray-500 hover:text-blue-600"  >
                    <FaEdit size={14} />
                  </button>
                  </div>
                </td>

                <td className="p-3">{cls.sectionsCount}</td>

                 <td className="p-3">{cls.subjectsCount}</td>

                <td className="p-3">
                  {cls.active ? "Yes" : "No"}
                </td>

                {/* <td className="p-3 text-right">

                  <button
                    onClick={() => editClass(cls)} className="text-blue-500 hover:underline"
                  >
                    <FaEdit size={14} />
                  </button>

                </td> */}

              </tr>

            ))
          ): (
              <tr>
                <td colSpan="4" className="text-center p-6 text-gray-500">
                  No students found
                </td>
              </tr>
            )}

          </tbody>

        </table>

      </div>

      {/* Popup Modal */}
      {selectedClass && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50 p-2">

          <div className="bg-white rounded-lg shadow-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">

            {/* Header */}
            <div className="flex justify-between items-center border-b p-4">
              <h2 className="text-lg text-blue-600 font-semibold">Class Details</h2>

              <div className="flex justify-end gap-6">
              <button
                type="button"
                onClick={saveClass} 
                className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
              >
                Save
              </button>
              <button
                onClick={onClose}
                className="text-red-500 font-bold"
              >
                X
              </button>
              </div>
            </div>

            <div className="p-4 space-y-6">
              {loading && <Loader />}
              {/* Class Info */}
              <div>
                <h3 className="font-bold mb-2">Class Information :</h3>

                <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3">

                  <div>
                  <label className="font-medium">Class Name</label>
                  <input
                    type="text" name="className" onChange={handleChange}
                    value={selectedClass.className || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                  </div>
                  <div>
                  <label className="font-medium">Description</label>
                  <input
                    type="text" name="description" onChange={handleChange}
                    value={selectedClass.description || ""}
                    className="w-full border rounded px-2 py-1"
                  />
                  </div>
                  <div>
                    <label className="font-medium">Active</label>
                    <select
                      value={selectedClass.active}
                      name="active" onChange={handleChange}
                      className="w-full border rounded px-2 py-1"
                    >
                      <option value={true}>Yes</option>
                      <option value={false}>No</option>
                    </select>
                </div>

                </div>
              </div>

              {/* Sections */}
              <div>
                <div className="flex justify-between items-center border-b">
                   <h3 className="font-bold mb-2">Sections :</h3>
                  <button
                    onClick={addSection}
                    className="text-blue-500 font-bold"
                  >
                   + Add
                  </button>
                </div>

                {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-3"> */}

                  {selectedClass?.sections?.map((sec,index) => (
                    
                     <div className="grid grid-cols-2 md:grid-cols-2 gap-3">
                    {/* Section Name */}
                    <div>
                      <label className="font-medium">Name</label>
                      <input
                        type="text"
                        name="sectionName"
                        value={sec.sectionName || ""}
                        onChange={(e) =>
                          handleSectionChange(index, e.target.name, e.target.value)
                        }
                        className="w-full border rounded px-2 py-1"
                      />
                    </div>

                    {/* Active + Delete in same row */}
                    <div className="grid grid-cols-2 gap-2 items-end">
                      <div>
                        <label className="font-medium">Active</label>
                        <select
                          value={sec.active}
                          name="active"
                          onChange={(e) =>
                            handleSectionChange(index, e.target.name, e.target.value)
                          }
                          className="w-full border rounded px-2 py-1"
                        >
                          <option value={true}>Yes</option>
                          <option value={false}>No</option>
                        </select>
                      </div>

                      <div className="flex items-end">
                        <button
                          type="button"
                          onClick={() => deleteSection(index)}
                          className="text-red-500 font-bold px-1"
                        >
                          <FaMinusCircle size={30}/>
                        </button>
                      </div>
                    </div>
                  </div>
                  ))}

                {/* </div> */}
              </div>

              {/* Subjects */}
              <div>
                <div className="flex justify-between items-center border-b">
                   <h3 className="font-bold mb-2">Subjects :</h3>
                  <button
                    onClick={addSubject}
                    className="text-blue-500 font-bold"
                  >
                   + Add
                  </button>
                </div>


                  {selectedClass?.subjects?.map((sub,index) => (
                    
                     <div className="grid grid-cols-2 md:grid-cols-2 gap-3">
                    {/* Subject Name */}
                    <div>
                      <label className="font-medium">Name</label>
                      <input
                        type="text"
                        name="subjectName"
                        value={sub.subjectName || ""}
                        onChange={(e) =>
                          handleSubjectChange(index, e.target.name, e.target.value)
                        }
                        className="w-full border rounded px-2 py-1"
                      />
                    </div>

                    {/* Code + Delete in same row */}
                    <div className="grid grid-cols-2 gap-2 items-end">
                      <div>
                        <label className="font-medium">Code</label>
                        <input
                        type="text"
                        name="subjectCode"
                        value={sub.subjectCode || ""}
                        onChange={(e) =>
                          handleSubjectChange(index, e.target.name, e.target.value)
                        }
                        className="w-full border rounded px-2 py-1"
                      />
                      </div>

                      <div className="flex items-end">
                        <button
                          type="button"
                          onClick={() => deleteSubject(index)}
                          className="text-red-500 font-bold px-1"
                        >
                          <FaMinusCircle size={30}/>
                        </button>
                      </div>
                    </div>
                  </div>
                  ))}

              </div>

            </div>

          </div>

        </div>

      )}

    </div>

  );
}